import { defineStore } from 'pinia'
import { TokenService } from '../services/api/storage.service'

export const useUserStore = defineStore('user', {
  state: () => {
    const userInstance = TokenService.getUser()

    return {
      userName: 'Vasili Savitski',
      email: 'vasili@gmail.com',
      memberSince: '8/12/2020',
      pfp: 'https://picsum.photos/id/22/200/300',
      is2FAEnabled: false,
      userInstance: userInstance ? JSON.parse(userInstance) : null,
      accessToken: TokenService.getToken() || null,
    }
  },

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },
    setUserInstance(userInstance: any) {
      TokenService.saveUser(JSON.stringify(userInstance))

      this.userInstance = userInstance
    },
    setAccessToken(token: any) {
      TokenService.saveToken(token)
      this.accessToken = token
    },
    deleteUserInstance() {
      TokenService.removeUser()
      TokenService.removeToken()

      this.userInstance = null
      this.accessToken = null
    },
  },
})
